import { InjectionToken, Provider } from '@angular/core';
import { AnyAiAgentClientTool } from './types/client-tool.type';
import { AiAgentContextSource } from './types/context-source.type';

/** Multi token; each provider contributes an array, mirroring `provideMasterdataEntities`. */
export const SOFTLINE_AI_AGENT_CLIENT_TOOLS = new InjectionToken<AnyAiAgentClientTool[][]>(
  'SOFTLINE_AI_AGENT_CLIENT_TOOLS'
);

export function provideAiAgentClientTools(
  ...tools: AnyAiAgentClientTool[]
): Provider {
  return {
    provide: SOFTLINE_AI_AGENT_CLIENT_TOOLS,
    multi: true,
    useValue: tools,
  };
}

export const SOFTLINE_AI_AGENT_CONTEXT_SOURCES = new InjectionToken<
  AiAgentContextSource[]
>('SOFTLINE_AI_AGENT_CONTEXT_SOURCES');

/** A factory, not a value: a source's signals are built from injected services. */
export function provideAiAgentContextSource(
  factory: () => AiAgentContextSource
): Provider {
  return {
    provide: SOFTLINE_AI_AGENT_CONTEXT_SOURCES,
    multi: true,
    useFactory: factory,
  };
}

/**
 * Masterdata entities offered for `@`-mentions and to `list_masterdata_entities`,
 * by registered entity name. Override to widen or narrow the default set.
 */
export const SOFTLINE_AI_AGENT_MENTION_ENTITIES = new InjectionToken<string[]>(
  'SOFTLINE_AI_AGENT_MENTION_ENTITIES',
  { factory: () => ['customer', 'product', 'product-group'] }
);
